import Stack from '@mui/material/Stack/Stack';
import { useTheme } from '@mui/material/styles';

import { Box, Typography } from '../material';
import CXTabLink from './cx-tab-link.component';
import CXTabScrollButton from './cx-tab-scroll-button.component';
import { NoBackgroundTab, NoBackgroundTabs, StyledTab, StyledTabs } from './cx-tabs.style';
import { CXTabItem } from './cx-tabs.type';

export const CXTabs: React.FC<{
  items: CXTabItem[];
  activeTab?: string;
  fullWidth?: boolean;
  noBackground?: boolean;
  backgroundColor?: string;
  tabContainerStyle?: Object;
  pt?: string;
  exploreFilters?: React.ReactNode;
}> = ({
  items,
  activeTab,
  fullWidth = true,
  pt = 2,
  tabContainerStyle = {},
  noBackground,
  backgroundColor,
  exploreFilters,
}) => {
  const { palette } = useTheme();

  if (!items) {
    return <></>;
  }

  let TabsComponent = StyledTabs;
  let TabComponent = StyledTab;

  if (noBackground) {
    TabsComponent = NoBackgroundTabs;
    TabComponent = NoBackgroundTab;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        pt,
        backgroundColor: backgroundColor ?? palette.Background,
        position: 'relative',
        alignItems: 'center',
        pointerEvents: 'all',
      }}
    >
      <TabsComponent
        additionalStyle={tabContainerStyle}
        value={activeTab}
        variant="scrollable"
        scrollButtons="auto"
        ScrollButtonComponent={CXTabScrollButton}
        className={fullWidth ? 'full-width' : undefined}
        sx={{ flex: 1, minWidth: 0 }}
      >
        {items &&
          items.map((item) => (
            <TabComponent
              key={item.value}
              label={
                <Typography variant="caption" fontWeight={500}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    {item.icon ? item.icon : null}
                    {item.label}
                  </Stack>
                </Typography>
              }
              value={item.value}
              to={item.to}
              state={item.state}
              component={CXTabLink}
              disabled={item.disabled}
              className={fullWidth ? 'full-width' : undefined}
            />
          ))}
      </TabsComponent>

      {exploreFilters && (
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: -12,
            display: 'flex',
            gap: 1,
            pr: 1,
          }}
        >
          {exploreFilters}
        </Box>
      )}
    </Box>
  );
};
